import { Tooltip } from "antd";

const formattedCategories = (categories) => {
  return categories.map((category) => {
    const { id, name, children } = category;
    const treeCategories = {
      value: id,
      title:
        category?.isSpecial === 1 ? (
          <div style={{ color: "#acacac" }}>{name}</div>
        ) : (
          <div>{name}</div>
        ),
    };
    if (children && children.length > 0) {
      treeCategories.children = formattedCategories(children);
    }

    return treeCategories;
  });
};

const formatPlanCompta = (categories, shouldTruncate = false) => {
  return categories.map((category) => {
    const { id, name, children } = category;

    const truncatedName =
      shouldTruncate && name?.length > 28 ? name.slice(0, 28) + "..." : name;

    // Always wrap in Tooltip to show full text on hover, even if not truncated
    // This ensures users can see the full label when it's ellipsized by CSS
    const treeCategories = {
      value: id,
      disabled: false,
      title: (
        <Tooltip title={name} placement="top">
          <div title={name}>{truncatedName}</div>
        </Tooltip>
      ),
    };
    if (children && children.length > 0) {
      treeCategories.children = formatPlanCompta(children, shouldTruncate);
    }

    return treeCategories;
  });
};

export { formatPlanCompta };

/** Ancestor ids so TreeSelect can open the path to a selected subcategory. */
export const getCategoryAncestorKeys = (categories, categoryId) => {
  if (categoryId == null || !Array.isArray(categories) || categories.length === 0) {
    return [];
  }

  const target = String(categoryId);

  const findAncestorPath = (nodes, path = []) => {
    for (const node of nodes || []) {
      const nodeId = String(node.id ?? node.value);
      if (nodeId === target) {
        return path;
      }
      if (node.children?.length) {
        const found = findAncestorPath(node.children, [...path, nodeId]);
        if (found) {
          return found;
        }
      }
    }
    return null;
  };

  return findAncestorPath(categories) || [];
};

export default formattedCategories;
